import { render, staticRenderFns } from "./MarketPlaceDetails.vue?vue&type=template&id=1f15652f&scoped=true&"
import script from "./MarketPlaceDetails.vue?vue&type=script&lang=js&"
export * from "./MarketPlaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./MarketPlaceDetails.vue?vue&type=style&index=0&id=1f15652f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15652f",
  null
  
)

export default component.exports